import { Button, ButtonGroup, Card, CardActions, CardContent, CardMedia, Typography, styled } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface IPresentation {
    img: string;
    title: string;
    detail: string;
    guide_link?: string;
    buy_link?: string;
  }
const Presentation: React.FC<IPresentation> = ({img, title, detail, guide_link= "", buy_link = ""}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const CustomTypography = styled(Typography)({
      whiteSpace: "pre-wrap"
    });
    
    return (
      <Card elevation={12} style={{width: "100%"}}>
        <CardMedia
        
          sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
          component="img"
          height={(guide_link || buy_link) ? "240" : "320"}
          title={title}
          image={img}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div" align="center" whiteSpace={"pre-wrap"}>
            {title}
          </Typography>
          <CustomTypography align="center">
            {detail}
          </CustomTypography>
        </CardContent>
        <CardActions>
          <ButtonGroup orientation="vertical" fullWidth>
            {(guide_link !== "") && (
          <Button variant="outlined" onClick={() => navigate(guide_link)}>
            {t("common.guide")}
          </Button>            )  
            }
            {(buy_link !== "") && (
          <Button variant="contained" onClick={() => navigate(buy_link)}>
            {t("common.buy")}
          </Button>    )          
            }
          </ButtonGroup>
        </CardActions>
      </Card>
    );
} 

export default React.memo(Presentation);